import classNames from 'classnames';
import { SwiperSlide, Swiper } from 'swiper/react';
import 'swiper/css';
import SwiperCore, { Navigation } from 'swiper';
import { ReactComponent as SvgArrowWhiteBg } from 'public/assets/icons/arrow-white-bg.svg';
import { useRef, useCallback } from 'react';
import { IFirstHandReport } from 'api/home/types';
import { IResortPathInfo } from 'api/resort/types';
import { FirstHandReportItem } from './FirstHandReportItem';
import styles from './styles.module.scss';

SwiperCore.use([Navigation]);

const swiperBreakpoints = {
  375: {
    slidesPerView: 1.2,
  },
  640: {
    slidesPerView: 1.7,
  },
  1200: {
    slidesPerView: 3,
  },
};

interface Props {
  title: string;
  slides: JSX.Element[];
  reports: IFirstHandReport[];
  regionResorts: Array<IResortPathInfo>;
  controlsHiddenOnMobile?: boolean;
}

export const NewGuideSlider = ({
  title, reports, regionResorts,
}: Props) => {
  const sliderRef = useRef<SwiperCore | null>(null);

  const resortPathInfoByUuid = new Map<number, IResortPathInfo>(
    (regionResorts ?? []).map((resort) => [Number(resort.uuid), resort]),
  );

  const shouldShowNavigation = reports.length > 3;

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.slideNext();
  }, []);

  return (
    <section className={classNames(styles.wrapper, 'mt-4')}>
      {title && (
        <div className={styles.header}>
          <h2>{title}</h2>
        </div>
      )}
      <div className={styles.wrapperBox}>
        <div className={styles.sliderWrapper}>
          {shouldShowNavigation && (
            <>
              <button
                type="button"
                className={classNames(
                  styles.swiperNavButton,
                  styles.swiperButtonPrev,
                )}
                onClick={handlePrev}
              >
                <SvgArrowWhiteBg />
              </button>
              <button
                type="button"
                className={classNames(
                  styles.swiperNavButton,
                  styles.swiperButtonNext,
                )}
                onClick={handleNext}
              >
                <SvgArrowWhiteBg />
              </button>
            </>
          )}
          <Swiper
            slidesPerView="auto"
            breakpoints={swiperBreakpoints}
            spaceBetween={16}
            className={styles.swiper}
            onSwiper={(swiperInstance) => {
              sliderRef.current = swiperInstance;
            }}
          >
            {reports
              .filter((item) => item.largeImage !== null)
              .map((item) => (
                <SwiperSlide
                  key={item.uuid}
                  className={styles.slide}
                >
                  <FirstHandReportItem
                    {...item}
                    resortPathInfo={resortPathInfoByUuid.get(item.resortUuid)}
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};
